import moment from "moment";

export default (markets, plan) => {
  // promise
  return new Promise((resolve, reject) => {
    const fromDate = moment("2024-11-01");
    const toDate = moment("2025-11-01");
    const items = [];
    const fields = [];
    // Create list of weeks between two dates
    const weeks = [];
    while (fromDate.isBefore(toDate)) {
      weeks.push(fromDate.format("WW-YYYY"));
      fromDate.add(1, "week");
    }
    markets = markets.map((market) => market.name);

    for (let i = 0; i < weeks.length; i++) {
      const item = {
        week: weeks[i]
      };
      for (let market of markets) {
        const planItems = plan.filter((p) => p.week === weeks[i] && p.market_name === market);
        item[market] = {};
        item[market]["percentage"] = 0;
        item[market]["current"] = 0;
        item[market]["total"] = 0;
        if (planItems.length > 0) {
          const value = planItems.reduce((a, b) => a + parseFloat(b.kilograms), 0);
          const current = planItems.reduce((a, b) => a + parseFloat(b.completed_kilograms || 0), 0);
          const percentage = (current / value) * 100;
          item[market]["percentage"] = percentage;
          item[market]["current"] = current;
          item[market]["total"] = value;
        }
      }
      const totalByWeekItems = plan.filter((p) => p.week === weeks[i]);
      const totalKilogramsPerWeek = totalByWeekItems.reduce((a, b) => a + parseFloat(b.kilograms), 0);
      const totalKilogramsPerDay = totalKilogramsPerWeek / 5.5;
      item["total"] = totalKilogramsPerWeek | 0;
      item["kgDia"] = totalKilogramsPerDay | 0;
      items.push(item);
    }

    fields.push({ key: "week", stickyColumn: true, isRowHeader: true, variant: "secondary", class: "w-5 " });
    for (let market of markets) {
      fields.push({ key: market, class: "text-center clicableCell" });
    }
    fields.push({
      key: "total",
      stickyColumn: true,
      isRowHeader: true,
      variant: "secondary",
      class: "text-right w-5"
    });
    fields.push({
      key: "kgDia",
      stickyColumn: true,
      isRowHeader: true,
      variant: "secondary",
      class: "text-right w-5"
    });

    resolve({ items, fields });
  });
};
